<script setup lang="ts">
const { RemoteConfigurationStore } = stores()

const message = computed(() => {
  switch (RemoteConfigurationStore.value?.ramoEnum) {
    case 'Auto':
      return 'El precio indicado podrá estar sujeto a ajustes menores, conforme a las condiciones adicionales y a los resultados obtenidos de la inspección del vehículo previa a la emisión de la poliza.'
    default:
      return null
  }
})
</script>
<template>
  <NoteComponent
    v-if="message"
    :message
  />
</template>
